class RelatedProducts extends HTMLElement {
  connectedCallback() {
    if (this.loaded) return;
    this.loaded = true;
    this.controller = new AbortController();
    this.observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.load();
    }, {rootMargin:'0px 0px 500px 0px'});
    this.observer.observe(this);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.controller?.abort();
  }
  async load() {
    try {
      const {profile, rank} = await import(this.dataset.matchingUrl);
      const source = {id:this.dataset.productId, title:this.dataset.productTitle, type:this.dataset.productType};
      const queries = profile(source).queries;
      const root = window.Shopify?.routes?.root || '/';
      const results = await Promise.allSettled(queries.map(async q => {
        const params = new URLSearchParams({q, 'resources[type]':'product', 'resources[limit]':'10', 'resources[options][unavailable_products]':'hide'});
        const response = await fetch(root + 'search/suggest.json?' + params, {signal:this.controller.signal});
        if (!response.ok) throw new Error('Related product search unavailable');
        return (await response.json()).resources.results.products;
      }));
      const candidates = results.filter(result => result.status === 'fulfilled').flatMap(result => result.value);
      const matches = rank(source, candidates, Math.min(Number(this.dataset.limit) || 4, 10));
      const cards = await Promise.allSettled(matches.map(async product => {
        const url = new URL(root + 'products/' + encodeURIComponent(product.handle), location.origin);
        url.searchParams.set('section_id', 'pt-related-product-card');
        const response = await fetch(url, {signal:this.controller.signal});
        if (!response.ok) throw new Error('Related product card unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = document.querySelector('[data-related-card]');
        // Availability is rechecked by Liquid at the time the card is rendered.
        if (!card || card.dataset.productId !== String(product.id)) return null;
        return card;
      }));
      if (!this.isConnected) return;
      const grid = this.querySelector('[data-related-grid]');
      cards.filter(result => result.status === 'fulfilled' && result.value).forEach(result => grid.append(result.value));
      const count = grid.children.length;
      this.dataset.matchCount = String(count);
      if (count) this.querySelector('[data-related-content]').hidden = false;
      else this.hidden = true;
    } catch (error) {
      if (error.name !== 'AbortError') this.hidden = true;
    }
  }
}
if (!customElements.get('pt-related-products')) customElements.define('pt-related-products', RelatedProducts);
